import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchSetCostReportSelection } from '../services/patchSetCostReportSelection.service';

export const saveCostReportSelection = createAsyncThunk(
  'expenseTracking/saveCostReportSelection',
  async (
    { reportPK, selectedRecordIds, selectedInvoiceIds, recordTimeUpdates },
    { getState }
  ) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const updated = await patchSetCostReportSelection(selectedProjectId, {
      reportPK,
      selectedRecordIds,
      selectedInvoiceIds,
      recordTimeUpdates,
    });

    return updated;
  }
);
